import {
  ThgPageViewModelGen,
  ThgThgMeterReadingControllerFindAllParamsGen,
  ThgThgMeterReadingViewModelGen
} from "@/services/thg/v1/data-contracts";
import store from "@/store/VuexPlugin";
import { Action, getModule, Module } from "vuex-module-decorators";
import { BasePagination, FilterTypes, IPaginationFilterListElement } from "./base-pagination.store";
import { PageOrderEnum } from "@/lib/enum/pageOrder.enum";
import meterReadingAdminService from "@/services/thg/services/meterReadingAdminService";
import { ImpactTypeEnum } from "@/views/thg/enum/impact-type.enum";
import { ThgStatusEnum } from "../enum/thg/thg-status.enum";
import { CountryCodeEnum } from "@/lib/enum/country-code.enum";

@Module({
  dynamic: true,
  namespaced: true,
  name: "meterReadingPaginatedStore",
  store
})
export class MeterReadingPaginatedStore extends BasePagination<
  ThgThgMeterReadingViewModelGen,
  ThgThgMeterReadingControllerFindAllParamsGen
> {
  protected _pageOrder: PageOrderEnum = PageOrderEnum.DESCENDING;
  protected _itemsPerPage = 100;
  protected _totalPages = 0;
  protected _paginationList: ThgThgMeterReadingViewModelGen[] = [];
  protected _currentPage = 1;
  protected _totalItems = 0;
  protected _isLoadAll = false;
  protected _filterList: IPaginationFilterListElement[] = [
    { key: "userId", type: FilterTypes.OBJECT_ID },
    { key: "partnerId", type: FilterTypes.OBJECT_ID },
    { key: "status", type: FilterTypes.ENUM, enum: ThgStatusEnum },
    { key: "impactType", type: FilterTypes.ENUM, enum: ImpactTypeEnum },
    { key: "impactFactor", type: FilterTypes.NUMBER },
    { key: "code", type: FilterTypes.STRING },
    { key: "campaign", type: FilterTypes.STRING },
    { key: "year", type: FilterTypes.NUMBER },
    { key: "isBillingInformationComplete", type: FilterTypes.BOOLEAN },
    { key: "_id", type: FilterTypes.OBJECT_ID },
    { key: "countryCode", type: FilterTypes.ENUM, enum: CountryCodeEnum }
  ];

  @Action
  protected async loadDocuments(
    query: ThgThgMeterReadingControllerFindAllParamsGen
  ): Promise<
    ThgPageViewModelGen & {
      data?: ThgThgMeterReadingViewModelGen[] | undefined;
    }
  > {
    return (await meterReadingAdminService.getAll(query)) as ThgPageViewModelGen & {
      data?: ThgThgMeterReadingViewModelGen[] | undefined;
    };
  }
}

export const MeterReadingPaginatedModule = getModule(MeterReadingPaginatedStore);
